import "./GlossaryOfHospitalityRevenueManagement.module.css";
import Header from "@/reusable_sections/Header";
import HeroGlossary from "./sections/HeroGlossary";
import RevenueGlossary from "./sections/RevenueGlossary";
import Footer from "@/reusable_sections/Footer";
export default function GlossaryOfHospitalityRevenueManagementPage() {
  return <div>
      <Header />
      <HeroGlossary />
      <RevenueGlossary />
      <Footer />
    </div>;
}